import getFormDefaultState from './formDefaultState'

export default () => ({
  source: {
    loading: false,
    collections: [],
    favorites: [],
    inventory: [],
  },
  alreadyUsedNames: [],
  loadedCampaignName: null,
  userLogos: [],
  campaignsTags: [],
  breadcrumbs: [
    {
      routeName: 'CreateCampaignSource',
      title: 'Select gifts',
    },
  ],
  form: {
    ...getFormDefaultState()
  },
})
